import { Button, Form, Input, Flex } from "antd";
import { FORM_REQUIRED } from "../../../configs/configs";
import { useEffect, useState, useContext } from "react";
import useFetch from "../../../hooks/useFetch";
import { IndexContext } from "../../../context/IndexContext";

function AreaForm(props) {
  const {
    mode,
    siteID,
    setIsAreaFormModalOpen,
    refreshList,
    initialValues,
    setSelectedInfoArea,
  } = props;

  const [fetchWrapper] = useFetch();

  const [areaForm] = Form.useForm();

  const [loadingSubmitButton, setLoadingSubmitButton] = useState(false);

  // load index context
  const { messageApi } = useContext(IndexContext);

  /* API to add area */
  function addArea(user_inputs) {
    setLoadingSubmitButton(true);
    fetchWrapper({
      endpoint_url: "site_management/addArea",
      body: {
        site_id: siteID,
        area_name: user_inputs.Name,
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          messageApi.open({
            type: "success",
            content: fetch_output.message,
          });
          setIsAreaFormModalOpen(false);
          areaForm.resetFields();
        } else {
          messageApi.open({
            type: "error",
            content: fetch_output.error,
          });
        }
        setLoadingSubmitButton(false);
        refreshList();
      },
    });
  }

  /* API to edit area */
  function editArea(user_inputs) {
    setLoadingSubmitButton(true);
    fetchWrapper({
      endpoint_url: "site_management/editArea",
      body: {
        area_id: initialValues.ID,
        area_name: user_inputs.Name,
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          messageApi.open({
            type: "success",
            content: fetch_output.message,
          });
          setIsAreaFormModalOpen(false);
          areaForm.resetFields();
          refreshList();
          setSelectedInfoArea(null);
        } else {
          messageApi.open({
            type: "error",
            content: fetch_output.error,
          });
        }
        setLoadingSubmitButton(false);
      },
    });
  }

  /* API to check whether area name is unique */
  function checkUniqueAreaName(area_name, callback) {
    fetchWrapper({
      endpoint_url: "site_management/checkUniqueAreaName",
      body: {
        site_id: siteID,
        area_id: initialValues ? initialValues.ID : null,
        area_name: area_name ? area_name : "",
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          if (fetch_output.is_unique === true) {
            callback(); // No error, so pass an empty callback
          } else {
            callback(
              "Area name already exists. Please input another area name."
            );
          }
        } else {
          messageApi.open({
            type: "error",
            content: fetch_output.error,
          });
        }
      },
    });
  }

  useEffect(() => {
    if (mode === "edit") {
      if (initialValues) {
        areaForm.setFieldsValue(initialValues);
      }
    }
  }, [mode, initialValues]);

  return (
    <>
      <Form
        form={areaForm}
        name="area-form"
        labelCol={{
          span: 9,
        }}
        wrapperCol={{
          span: 15,
        }}
        onFinish={(values) => {
          if (mode === "add") {
            addArea(values);
          } else {
            editArea(values);
          }
        }}
        autoComplete="off"
      >
        <Form.Item
          label="Area Name"
          name="Name"
          rules={[
            {
              required: FORM_REQUIRED,
              message: "Area name cannot be empty.",
            },
            {
              validator: (_, value, callback) => {
                checkUniqueAreaName(value, callback);
              },
            },
          ]}
          validateTrigger="onBlur"
        >
          <Input />
        </Form.Item>

        <Flex justify="center">
          <Button
            className="mr-2"
            onClick={() => {
              setIsAreaFormModalOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loadingSubmitButton}
          >
            Submit
          </Button>
        </Flex>
      </Form>
    </>
  );
}

export default AreaForm;
